import React, { Fragment } from 'react';
import { motion } from 'framer-motion';
import { ChevronRightIcon } from 'lucide-react';
import { Link } from 'react-router-dom';
interface PageHeroProps {
  title: string;
  subtitle?: string;
  breadcrumbs?: {
    label: string;
    path?: string;
  }[];
}
export function PageHero({
  title,
  subtitle,
  breadcrumbs
}: PageHeroProps) {
  return <div className="bg-au-green text-white py-16" data-id="element-305">
      <div className="max-w-7xl mx-auto px-4" data-id="element-306">
        {breadcrumbs && <div className="flex items-center gap-2 text-sm mb-4 text-au-green-light" data-id="element-307">
            {breadcrumbs.map((crumb, index) => <Fragment key={index} data-id="element-308">
                {crumb.path ? <Link to={crumb.path} className="hover:text-white transition-colors" data-id="element-309">
                    {crumb.label}
                  </Link> : <span data-id="element-310">{crumb.label}</span>}
                {index < breadcrumbs.length - 1 && <ChevronRightIcon size={16} data-id="element-311" />}
              </Fragment>)}
          </div>}

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5
      }} data-id="element-312">
          <h1 className="text-4xl md:text-5xl font-serif mb-4" data-id="element-313">{title}</h1>
          <div className="w-24 h-1 bg-au-gold mb-4" data-id="element-314"></div>
          {subtitle && <p className="text-xl text-au-green-light max-w-3xl" data-id="element-315">{subtitle}</p>}
        </motion.div>
      </div>
    </div>;
}